<template>
  <div>
    <v-row>
      <v-col cols="12" sm="4">
        <v-row align="center" no-gutters>
          <span class="overline font-weight-medium text-darker"
            >Total de la période</span
          >
          <v-row align="end" justify="end" no-gutters>
            <span class="subtitle-1 ml-2">{{ getTotal }}</span>
            <span class="caption ml-1">$</span>
          </v-row>
        </v-row>
      </v-col>
      <v-col cols="12" sm="4">
        <v-row align="center" no-gutters>
          <span class="caption mx-1">|</span>
          <span class="overline font-weight-medium text-darker"
            >Cost de la période</span
          >
          <v-row align="end" justify="end" no-gutters>
            <span class="subtitle-1 ml-2">{{ getCostTotal }}</span>
            <span class="caption ml-1">$</span>
            <span class="subtitle-1 ml-2">( {{ getPercentCostTotal }}</span>
            <span class="caption ml-1">%</span>
            <span class="subtitle-1 ml-1">)</span>
          </v-row>
        </v-row>
      </v-col>
      <v-col cols="12" sm="4">
        <v-row align="center" no-gutters>
          <span class="caption mx-1">|</span>
          <span class="overline font-weight-medium text-darker"
            >Année Précédente</span
          >
          <v-row
            align="end"
            justify="end"
            no-gutters
            v-if="getTotalLastYear > 0"
          >
            <span class="subtitle-1 ml-2">{{ getTotalLastYear }}</span>
            <span class="caption ml-1 mr-3">$</span>
            <div v-if="getTotal > 0">
              <v-icon x-small left color="success" v-if="getLastYearDelta > 0">
                fa-chevron-up
              </v-icon>
              <v-icon x-small left class="ml-1" color="error" v-else>
                fa-chevron-down
              </v-icon>
              <span
                class="subtitle-1"
                :style="{
                  color: getLastYearDelta > 0 ? '#149911' : '#DE1A1A'
                }"
                >{{ getLastYearDelta }}</span
              >
              <span
                :style="{
                  color: getLastYearDelta > 0 ? '#149911' : '#DE1A1A'
                }"
                class="caption ml-1"
                >%</span
              >
            </div>
          </v-row>
          <v-row v-else align="end" justify="end" no-gutters>
            <span class="caption">Aucune donnée</span>
          </v-row>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { round10 } from "round10";
export default {
  name: "AnalyticSalesSummary",
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  computed: {
    getCurrentYearLen() {
      return this.data.map(x => x.sales).length;
    },
    getTotal() {
      return round10(
        this.data.map(x => Number(x.sales)).reduce((a, b) => a + b, 0),
        0
      );
    },
    getNetTotal() {
      return round10(
        this.data.map(x => Number(x.net_sales)).reduce((a, b) => a + b, 0),
        0
      );
    },
    getCostTotal() {
      return round10(
        this.data.map(x => Number(x.cost)).reduce((a, b) => a + b, 0),
        0
      );
    },
    getPercentCostTotal() {
      if (this.getTotal !== 0) {
        return round10((this.getCostTotal / this.getNetTotal) * 100, -2);
      } else {
        return 0;
      }
    },
    getTotalLastYear() {
      return round10(
        this.data
          .filter(x => x.sales !== null && x.sales !== 0)
          .map(x => Number(x.past_year_sales))
          .reduce((a, b) => a + b, 0),
        0
      );
    },
    getTotalLastWeek() {
      return round10(
        this.data
          .filter(x => x.sales !== null && x.sales !== 0)
          .map(x => Number(x.last_week_sales))
          .reduce((a, b) => a + b, 0),
        0
      );
    },
    getLastYearDelta() {
      if (this.getTotal !== 0) {
        return round10(
          ((this.getTotal - this.getTotalLastYear) / this.getTotal) * 100,
          0
        );
      } else {
        return 0;
      }
    },
    getLastWeekDelta() {
      if (this.getTotal !== 0) {
        return round10(
          ((this.getTotal - this.getTotalLastWeek) / this.getTotal) * 100,
          0
        );
      } else {
        return 0;
      }
    }
  }
};
</script>

<style scoped>
@media screen and (max-width: 600px) {
  .v-application span.title {
    font-size: 1.05rem !important;
  }
}
</style>
